<template>
</template>

<script>
export default {
 mounted() {
   this.$nextTick(() => {
     $(".badge-basket").removeClass("wk-basket-hide");
     $("#searchBox").removeClass("hide-onload");
     $('.ddcenter').on('shown.bs.dropdown', function () {
       jQuery(window).trigger('resize');
     });
     lozad('.wk-lazyload', {
       load: function (el) {
         el.src = el.dataset.src;
         el.onload = function () {
           el.classList.remove('wk-lazyload-init');
           el.classList.add('wk-fade')
         }
       }
     }).observe();

     document.onreadystatechange = () => {
    if (document.readyState == "complete") {
       
        const wkGridContainer = document.querySelector('.wk-grid-container');
    const wkGridItems = Array.from(document.querySelectorAll('.wk-grid-item'));
    const wkMaxRowWidth = 1340;
    const wkMaxRowWidthCategory = 975;
    const wkGap = 10; // Gap size in pixels
    const debounceDelay = 100;
    const resizeBreakpoint = 992;

    // Cache App.isCategoryView if it's a frequently accessed property
    const isCategoryView = () => App.isCategoryView;

    // Utility function to debounce events
    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    // Wait for all images to load
   async function wkWaitForImages() {
        const imagePromises = wkGridItems.map(wkItem => {
            const picture = wkItem.querySelector('picture');
            if (!picture) return Promise.resolve(null);

            const dataIesrc = picture.getAttribute('data-iesrc');
            if (!dataIesrc) return Promise.resolve(null);

            return loadImage(dataIesrc)
                .then(img => img)
                .catch(error => {
                    console.error(error);
                    return null;
                });
        });

        try {
            const images = await Promise.all(imagePromises);
            images.forEach((img, index) => {
                if (img) {
                    const wkItem = wkGridItems[index];
                    wkItem.dataset.width = img.naturalWidth;
                    wkItem.dataset.height = img.naturalHeight;
                }
            });
            wkAdjustGridLayout();
        } catch (error) {
            console.error('Error loading images:', error);
        }
    }

    // Function to load an image and return a Promise with the Image object
    function loadImage(src) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;

            // If the image is cached, resolve immediately
            if (img.complete && img.naturalWidth && img.naturalHeight) {
                resolve(img);
            } else {
                img.onload = () => resolve(img);
                img.onerror = () => reject(new Error('Image failed to load: ' + src));
            }
        });
    }

    // Adjust the grid layout based on image sizes
    function wkAdjustGridLayout() {
        const currentMaxRowWidth = isCategoryView() ? wkMaxRowWidthCategory : wkMaxRowWidth;
        adjustContainerWidth();

        let currentRowWidth = 0;
        let rowItems = [];
        let noSizeItems = [];

        // Batch style changes to minimize reflows
        const stylesToApply = [];

        wkGridItems.forEach(wkItem => {
            const imgWidth = parseInt(wkItem.dataset.width, 10);

            if (!imgWidth && wkItem.classList.contains('wk-grid-text')) {
                noSizeItems.push(wkItem);
                return;
            }

            if (imgWidth) {
                const additionalGap = rowItems.length > 0 ? wkGap : 0;
                if (currentRowWidth + additionalGap + imgWidth > currentMaxRowWidth) {
                    applyRowStyles(rowItems, currentRowWidth, currentMaxRowWidth, stylesToApply);
                    rowItems = [];
                    currentRowWidth = 0;
                }

                if (rowItems.length > 0) {
                    currentRowWidth += wkGap;
                }

                rowItems.push(wkItem);
                currentRowWidth += imgWidth;
            }
        });

        // Apply styles for the last row
        if (rowItems.length > 0) {
            applyRowStyles(rowItems, currentRowWidth, currentMaxRowWidth, stylesToApply);
        }

        // Apply styles for no size items
        if (noSizeItems.length > 0) {
            const remainingWidth = currentMaxRowWidth - currentRowWidth;
            const flexBasis = ((remainingWidth / currentMaxRowWidth) * 100 - 0.5).toFixed(2);
            noSizeItems.forEach(item => {
                stylesToApply.push(() => {
                    item.style.flexBasis = `${flexBasis}%`;
                });
            });
        }

        // Batch apply all style changes
        requestAnimationFrame(() => {
            stylesToApply.forEach(applyStyle => applyStyle());
        });
    }

    // Apply styles to a row of items
    function applyRowStyles(rowItems, rowWidth, maxRowWidth, stylesToApply) {
        const totalGapWidth = (rowItems.length - 1) * wkGap;
        rowItems.forEach(wkRowItem => {
            const wkRowItemWidth = parseInt(wkRowItem.dataset.width, 10);
            let flexBasis = ((wkRowItemWidth / (maxRowWidth - totalGapWidth)) * 100) - ((wkGap / maxRowWidth) * 100);
            if (wkRowItem.classList.contains('wk-grid-text')) {
                flexBasis -= 0.5;
            }
            flexBasis = flexBasis.toFixed(2);
            stylesToApply.push(() => {
                wkRowItem.style.flexBasis = `${flexBasis}%`;
            });
        });
    }

    // Adjust the container's max width based on the view
    function adjustContainerWidth() {
        if (isCategoryView() && wkGridContainer) {
            wkGridContainer.style.maxWidth = '975px';
        } else if (wkGridContainer) {
            wkGridContainer.style.maxWidth = '1340px';
        }
    }

    // Handle window resize
    const handleResize = debounce(() => {
        if (window.innerWidth > resizeBreakpoint) {
            wkAdjustGridLayout();
        }
        adjustContainerWidth();
    }, debounceDelay);

    // Initialize
    wkWaitForImages();
    window.addEventListener('resize', handleResize);

  }
}

   });
  }
}
</script>
